import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, TitleStrategy, withPreloading } from '@angular/router';
import { AbstractSecurityStorage, provideAuth, StsConfigLoader } from 'angular-auth-oidc-client';
import { NeoMaskedInputModule } from '@neogov/pattern-library/neo-masked-input';
import { NeoNativeDateModule } from '@neogov/pattern-library/core';
import { NeoDialogModule } from '@neogov/pattern-library/neo-dialog';
import { NeoFlyoutV2Module } from '@neogov/pattern-library/neo-flyout-v2';
import { NeoModalModule } from '@neogov/pattern-library/neo-modal';
import { NeoToastModule } from '@neogov/pattern-library/neo-toast';
import { NeoTooltipV2Module } from '@neogov/pattern-library/neo-tooltip-v2';

import { routes } from './app.routes';
import {
  CmTitleStrategy,
  EIDCStoreProvider,
  httpErrorInterceptor,
  initializeAppConfig,
  OidcConfigLoader,
  tokenInterceptor,
} from './core';


const prefersReducedMotion =
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    prefersReducedMotion ? provideNoopAnimations() : provideAnimations(),
    provideAppInitializer(initializeAppConfig()),
    provideHttpClient(withInterceptors([tokenInterceptor, httpErrorInterceptor])),
    provideAuth({
      loader: {
        provide: StsConfigLoader,
        useClass: OidcConfigLoader,
      },
    }),
    {
      provide: AbstractSecurityStorage,
      useClass: EIDCStoreProvider,
    },
    {
      provide: TitleStrategy,
      useClass: CmTitleStrategy,
    },
    importProvidersFrom(NeoNativeDateModule, NeoToastModule, NeoDialogModule, NeoFlyoutV2Module, NeoModalModule, NeoTooltipV2Module, NeoMaskedInputModule),
  ],
};
